module.exports = __webpack_public_path__ + "static/media/no-data.f65f1a19.png";